var map = {
	"./1.jpg": "8d86",
	"./10.jpg": "5fdd",
	"./11.jpg": "52ef",
	"./12.jpg": "43b6",
	"./13.jpg": "b070",
	"./14.jpg": "8491",
	"./15.jpg": "e9ee",
	"./16.jpg": "b9f3",
	"./2.jpg": "802d",
	"./3.jpg": "2162",
	"./4.jpg": "f1f7",
	"./5.jpg": "8c45",
	"./6.jpg": "e351",
	"./7.jpg": "1458",
	"./8..jpg": "8f10",
	"./8.jpg": "48a7",
	"./9.jpg": "b95c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2406";